import state from './roomState'
import mutations from './roomMutations'
import getters from './roomGetters'
import actions from './roomActions'

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions
}
